import React from 'react'
import Grades from 'src/modules/MyClass/ELearningGrades'

const GradesPage = () => {
  return <Grades />
}

export default GradesPage
